import React from 'react';
import MenuContainer from './menucontainer.js';
import $ from 'jquery';


class MenuController extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
		this.onButtonClick = this.onButtonClick.bind(this);

		this.state = { containerShown : false };
	}

	componentDidMount() {
		var comp = this;

		$(document).off().on('click', function(e) {
			if(comp.state.containerShown && !e.target.closest(`.Menu-Button`)) {
				comp.setState({containerShown : false});
			}
		});
	}

	onClick(e) {
		//Send that click event up the ol' food chain after hiding the container
		this.setState({ containerShown : false });

		if(this.props.onClick) this.props.onClick(e);
	}

	onButtonClick(e) {
		//Open the menu or close it if already open

		this.setState({ containerShown : !this.state.containerShown });

		//Toggle open or close icon for main button here too but we'll set that up later
	}

	render() {

		var addHidden = (this.state.containerShown) ? '' : ' hidden';
		return (
			<div className={'Menu' + addHidden} >
				<div className='Menu-Button'>
					<button id={this.props.buttonid} onClick={this.onButtonClick}>
						{this.props.button_label}
						<div className="Menu-Arrow">
							<img src={process.env.PUBLIC_URL + "images/open-white-arrow-down.png"} alt='arrow down' />
						</div>
					</button>
				</div>
				<MenuContainer items={this.props.items} show={this.state.containerShown} onClick={this.onClick} />

			</div>
		);
	}

}

export default MenuController;